module.exports = __webpack_public_path__ + "static/media/matarou.a537b662.png";